import Button, { ButtonVariants } from '@/components/atoms/Button/Button';
import { Wrapper } from '@/components/template/PartnerTemplate/Wrapper';
import useWindowSize from '@/hooks/useWindowSize';
import scrollIntoView from '@/lib/scrollIntoView';
import { FC, MutableRefObject, useCallback } from 'react';

interface RefLabel {
  ref: MutableRefObject<HTMLElement | null>;
  label: string;
}

interface PartnerBarProps {
  wrapperRef: MutableRefObject<HTMLElement | null>;
  navButtons: RefLabel[];
  actionButton: RefLabel;
}

export const PartnerBar: FC<PartnerBarProps> = ({
  wrapperRef,
  navButtons,
  actionButton,
}) => {
  const { isDesktop, isML } = useWindowSize();

  const handleScrollToView = useCallback(
    (target: MutableRefObject<HTMLElement | null>) => {
      if (target?.current && wrapperRef.current) {
        scrollIntoView(
          target.current,
          isDesktop || isML
            ? wrapperRef.current.getBoundingClientRect().height +
                (document?.getElementById('main-nav')?.getBoundingClientRect()
                  ?.height || 0) +
                50
            : 0
        );
      }
    },
    [isDesktop, isML, wrapperRef]
  );
  return (
    <div className="flex w-full justify-center border-b border-neutral-300 bg-header-gradient backdrop-blur-header ml:border-none ml:shadow-xl">
      <Wrapper>
        <div className="flex w-full flex-row items-center justify-between py-l ml:py-m">
          <section className="flex items-center gap-3xl">
            {navButtons.map((navButton) => (
              <div
                key={navButton.label}
                className="flex cursor-pointer items-end gap-s border-b-2 border-transparent py-s hover:border-b-brandElectric/80"
                onClick={() => handleScrollToView(navButton.ref)}
                role="button"
                aria-label={`Scroll to ${navButton.label}`}
              >
                <span className="text-body1Medium text-brandMidnight">
                  {navButton.label}
                </span>
              </div>
            ))}
          </section>
          <section className="flex h-full items-center gap-2xl">
            <Button
              aria-label={`Scroll to ${actionButton.label}`}
              onClick={() => handleScrollToView(actionButton.ref)}
              variant={ButtonVariants.Tertiary}
              size="small"
            >
              {actionButton.label}
            </Button>
          </section>
        </div>
      </Wrapper>
    </div>
  );
};
